<template>
	<div class="container">
		<div class="box">
			<div class="title-c">个人资料</div>
			<div class="avatar">
				<el-upload :show-file-list="false" :on-success="handleAvatarSuccess" :action="uploadUrl">
					<div class="avatar-cnt">
						<img :src="userInfo.headPic!=''?userInfo.headPic:require('@/assets/default-avatar.png')" />
						<span>点击修改头像</span>
					</div>
				</el-upload>
			</div>
			<div class="avatar font-18">总积分{{userInfo.integralNum}}</div>
			<div class="formlist">
				<div class="color-98 font-16">基础资料</div>
			</div>
			<div class="formlist">
				<span class="form-item">昵称</span>
				<input v-model="userInfo.nickName" class="inputtext" placeholder="请输入" />
			</div>
			<div class="formlist">
				<span class="form-item">姓名</span>
				<input v-model="userInfo.realName" class="inputtext" placeholder="请输入" />
			</div>
			<div class="formlist">
				<span class="form-item">麒麟ID</span>
				<input v-model="userInfo.kylinsoftUserId" disabled class="inputtext" placeholder="请输入" />
			</div>
			<div class="line"></div>
			<div class="formlist">
				<div class="color-98 font-16">详细资料</div>
			</div>
			<div class="formlist">
				<span class="form-item">性别</span>
				<div class="radio-sex">
					<el-radio v-model="userInfo.sex" label="男">男</el-radio>
					<el-radio v-model="userInfo.sex" label="女">女</el-radio>
				</div>
			</div><div class="formlist" style="display: none;">
				<span class="form-item">身份证号</span>
				<input v-model="userInfo.idCard" class="inputtext" placeholder="未设置" />
			</div>
			<div class="formlist">
				<span class="form-item">地区</span>
				<input v-model="userInfo.address" class="inputtext" placeholder="未设置" />
			</div>
			<div class="formlist">
				<span class="form-item">生日</span>
				<el-date-picker style="width:486px" v-model="userInfo.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
				</el-date-picker>
			</div>
			<div class="formlist">
				<span class="form-item">个性签名</span>
				<input v-model="userInfo.personSign" class="inputtext" placeholder="未设置" />
			</div>
			<div class="formlist height">
				<span class="form-item">主页背景</span>
				<!-- <UploadImg :limit="1" :imgUrl="userInfo.backgroundPic" @uploadDelete="uploadDelete" @uploadSuccess="uploadSuccess"/> -->
				<single-upload class="width-full" v-model="userInfo.backgroundPic" @getImgData="uploadSuccess($event)"></single-upload>
			</div>
			<div class="formlist">
				<span class="form-item long">是否让他人查看自己关注内容</span>
				<div class="radio-sex">
					<el-radio v-model="userInfo.beViewFlag" :label="1">是</el-radio>
					<el-radio v-model="userInfo.beViewFlag" :label="0">否</el-radio>
				</div>
			</div>
			<div class="btns">
				<a @click="toModify" href="javascript:;" class="active">保存</a>
			</div>
		</div>
		<div class="box">
			<div class="title-c">
				<div>最近访问圈子</div>
				<div class="btn-more" @click="showJoinMore">
					<div>更多圈子</div>
					<span class="el-icon-caret-right"></span>
				</div>
			</div>
			<div class="circle-type" v-if="userId">
					<div class="circle-list-wrap" v-if="joinCircleList.length>4&&joinMoreClick==1">
						<div class="circle-list" @click="toCircleIndex(item.id)" v-for="(item, index) in joinCircleList" :key="index">
							<div class="circle-list-l" >
								<img :src="item.icon||require('@/assets/default-img.png')"/>
							</div>
							<div class="circle-list-r">
								<h3 >{{item.circleName}}</h3>
								<div class="circle-num">{{item.postNum}}帖子</div>
							</div>
						</div>
					</div>
					<div class="circle-list-wrap" v-else>
						<div class="circle-list"  @click="toCircleIndex(item.id)" v-for="(item, index) in joinCircleList" :key="index">
							<div class="circle-list-l" v-if="index<4">
								<img :src="item.icon||require('@/assets/default-img.png')"/>
							</div>
							<div class="circle-list-r" v-if="index<4">
								<h3>{{item.circleName}}</h3>
								<div class="circle-num">{{item.postNum}}帖子</div>
							</div>
						</div>
					</div>
					<!-- <div class="circle-list-more" v-if="joinCircleList.length>4&&joinMoreClick==0" @click="showJoinMore">
						查看更多({{joinCircleList.length-4}})<i class="el-icon-caret-bottom"></i>
					</div> -->
				</div>
		</div>
		<div class="box">
			<div class="title-c">活动参与列表</div>
			<ul class="list" v-if="postList.length >0">
				<li v-for="(item,index) in postList" @click="toDetail(item.id)" :key="index">
						<div class="list-img">
								<img :src="item.picUrl" />
						</div>
						<div class="list-title">
								<h3>{{item.name}}</h3>
						</div>
						<div class="list-tips">
								<div class="article-tags-wrap" v-if="item.talkName">
										<div class="article-tags">
												<span class="tags-icon">#</span>
												<span class="tags-name">{{item.talkName}}</span>
										</div>
								</div>
								<div class="sign" v-if="item.holdStatus!=2 && item.enrollFlag == 0" @click.stop="toSign(item)">报名</div>
								<div class="sign" v-if="item.holdStatus!=2 && item.enrollFlag == 1" @click.stop="toSign(item)">取消报名</div>
						</div>
						<div class="list-txt">
								<div class="list-txt-l">
										<span>浏览 {{item.viewNum || 0}}</span>
								</div>
								<div class="list-txt-r">
										时间：{{item.beginTime | datefmt('yyyy-MM-DD')}}～{{item.endTime | datefmt('yyyy-MM-DD')}}
								</div>
						</div>
						<div class="list-txtd">
								<div class="list-txt-l">
										<span>参与人数 {{item.enrollNum || 0}}</span>
								</div>
						</div>
				</li>
			</ul>
			<Empty v-if="!postList.length" content="该分类下无数据" />
			<Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange" />
		</div>
	</div>
</template>

<script>
	import singleUpload from '@/components/upload/singleUpload'
	
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	import qs from 'qs'
	export default {
		name: 'UserInfo',
		components: {
			singleUpload
		},
		data() {
			return {
				userInfo: {},
				joinCircleList: [],
				joinMoreClick: 0,
				picUrls: [],
				uploadUrl: '',
				postList: [],
				pageSize: 3,
				pageNum: 1
			}
		},
		watch: {
			'serInfo.backgroundPic'(newVal, oldVal){
				if(newVal.length>0){
					this.picUrls = newVal.join(',')
				}
			}
		},
		created() {
			this.uuid = localStorage.getItem('uuid') || ''
			this.userId = localStorage.getItem('userId') || ''
			this.uploadUrl = config.baseUrl + 'v1/upload/res'
			this.getUserInfo()
			if(this.userId) {
				this.getCircleCategory()
				this.getPostList()
			}
		},
		methods: {
			async getPostList() {
				// 活动列表
				let param = {
					userId: this.userId,
					pageSize: this.pageSize,
					pageNum: this.pageNum,
				}
				ajaxParam(param)
				const res = await post('v1/activity/myEnrollActivity', qs.stringify(param))
				if (res.data.code == 200) {
					this.postList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			pageChange(e) {
				this.postList = []
				this.pageNum = e.number
				this.getPostList()
			},
			// 活动
			toDetail(id) {
				this.$router.push({
						path: '/activityDetail?id=' + id
				})
			},
			showJoinMore(){
				this.joinMoreClick = 1
			},
			toCircleIndex(id){
				this.$router.push({
					path: '/circleIndex?id='+id
				})
			},
			//获取加入圈子
			async getCircleCategory(){
				let param = {
					userId: this.userId
				}
				ajaxParam(param)
				const res = await post('v1/circle/joinCircleList', qs.stringify(param))
				if(res.data.code==200){
					let list = res.data.list
					this.joinCircleList = list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			async getUserInfo() {
				let url = 'v1/user/getUserDetail'
				let param = {
					userId: this.userId,
					token: localStorage.getItem('token'),
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if (res.data.code == 200) {
					console.log(res)
					let userInfo = res.data.entity
					this.userInfo = userInfo
					this.userInfo.birthday = this.userInfo.birthdayStr
				}
			},
			async toModify() {
				let nickName = this.userInfo.nickName
				let realName = this.userInfo.realName
				if (this.userInfo.headPic.length <= 0) {
					this.$message.error('请上传头像！')
					return
				}
				if (nickName.length <= 0) {
					this.$message.error('昵称不能为空！')
					return
				}
				if (realName.length <= 0) {
					this.$message.error('姓名不能为空！')
					return
				}
				let param = {
					token: localStorage.getItem('token'),
					userId: localStorage.getItem('userId'),
					headPic: this.userInfo.headPic,
					nickName: this.userInfo.nickName,
					sex: this.userInfo.sex,
					realName: this.userInfo.realName,
					address:this.userInfo.address,
					birthday: this.userInfo.birthday,
					idCard: '',
					backgroundPic:this.userInfo.backgroundPic,
					personSign:this.userInfo.personSign,
					beViewFlag: this.userInfo.beViewFlag
					
				}
				ajaxParam(param)
				const res = await post('v1/user/updateUser', qs.stringify(param))
				if (res.data.code == 200) {
					this.$message.success('修改个人信息成功！')
					this.bus.$emit('resfreshheaPic')
				} else {
					this.$message.error(res.data.msg)
				}
			},
			handleAvatarSuccess(res) {
				this.userInfo.headPic = res.entity.fileUrl
			},
			
			uploadSuccess(e){
				console.log(e,111111)
				this.userInfo.backgroundPic = e
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		.box{
			background: #fff;
			padding: 20px;
			border-radius: 12px;
			margin-bottom: 40px;
		}
		.avatar {
			display: flex;
			justify-content: center;
		}

		.avatar-cnt {
			padding-bottom: 10px;

			img {
				width: 72px;
				height: 72px;
				margin-top: 10px;
				border-radius: 50%;
			}

			span {
				display: block;
				margin-top: 0px
			}
		}
		.line{
			width: 596px;
			height: 3px;
			background: #F7F7F7;
			border-radius: 3px;
			margin: 40px auto;
		}
		.formlist.height{
			height: 140px;
		}
		.formlist {
			width: 596px;
			margin: 0 auto;
			height: 36px;
			margin-top: 10px;
			line-height: 36px;
			clear: both;
			position: relative;
			.form-item.long{
				width: 210px;
			}
			.form-item {
				float: left;
				width: 90px;
				margin-right: 20px;
				text-align: left;
				font-size: 16px;

				i {
					padding-right: 5px;
					color: red;
				}
			}

			.inputtext {
				width: 486px;
				height: 36px;
				padding: 0 20px;
				background: #f7f7f7;
				border-radius: 6px;
				color: #606060;
				box-sizing: border-box;
			}
			.inputtext.long{
				width: 366px
			}
			.radio-sex {
				float: left;
			}

			.el-radio {
				font-size: 26px !important;
				margin-top: -5px
			}

			.el-radio__label,
			.el-checkbox__label {
				font-size: 14px !important;
			}

			/deep/ .el-input__inner {
				height: 36px
			}

		}

		.btns {
			display: flex;
			justify-content: center;
			margin-top: 40px;

			a {
				display: block;
				width: 88px;
				height: 34px;
				margin-left: 15px;
				background: rgba(50, 50, 50, .1);
				border-radius: 16px;
				line-height: 34px;
				text-align: center;
			}

			a:hover,
			a.active {
				background: #DD0515;
				color: #fff;
			}
		}
	}
	.title-c{
		font-size: 18px;
		display: flex;
		justify-content:space-between;
	}
	.btn-more{
		display: flex;
		font-size: 14px;
		color: #808080;
		align-items: center;
		cursor: pointer;
		.box-btn{
			width: 0;
			height: 0;
			border-top: 8px solid transparent;   /* 透明 */
			border-bottom: 8px solid transparent; /* 透明 */
			border-left: 10px solid #808080; 
			margin-left: 4px;
			margin-top: 2px;
		}
	}
	.circle-type{
		padding-bottom: 15px;
		h1{
			//margin: 15px 0 0;
			font-size: 12px;
			color: #666;
			opacity: .6;
		}
	}
	.circle-list-wrap{
		display: flex;
		flex-wrap: wrap;
		margin-top: 8px;
		.circle-list{
			display: flex;
			align-items: center;
			width: 25%;
			margin-bottom: 10px;
			padding: 0 10px;
			cursor: pointer;
			box-sizing: border-box;
			.circle-list-l{
				img{
					width: 50px;
					height: 50px;
					margin: 0 auto;
					border-radius: 15px;
				}
			}
			.circle-list-r{
				margin-left: 10px;
				overflow: hidden;
				h3{
					width: 100%;
					font-size: 14px;
					font-weight: bold;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					text-align: center;
					line-height: 30px;
				}
				.circle-num{
					margin: 4px 0 10px;
					opacity: .7;
					font-size: 12px;
				}
			}
			
			.enter-btn{
				width: 62px;
				height: 22px;
				border-radius: 14px;
				border: 1px solid #DD0515;
				line-height: 22px;
				text-align: center;
				font-size: 12px;
				color: #DD0515;
			}
			.entered{
				background: rgba(50,50,50,.1);
				border-color: rgba(50,50,50,.1);
				color: rgba(50,50,50,.3);
			}
		}
	}
	.circle-list-more{
		text-align: center;
		color: rgba(14,21,28,.3);
		cursor: pointer;
	}
	
	.list {
		display: flex;
		flex-wrap: wrap;

		li {
				display: flex;
				flex-direction: column;
				width: 32.3333%;
				margin-right: 1.3333%;
				margin-top: 16px;
				background: #fff;
				border: 1px solid rgba(50, 50, 50, .1);
				border-radius: 4px;
				box-sizing: border-box;
				cursor: pointer;
				overflow: hidden;

				.list-img {
						img {
								width: 100%;
								height: 240px;
								max-width: 380px;
								max-height: 214px;
						}
				}

				.list-title {
						margin-top: 12px;
						margin-bottom: 4px;
						padding: 0 17px;
						line-height: 24px;
						font-size: 16px;
						font-weight: bold;
						letter-spacing: .86px;
						-webkit-line-clamp: 1;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						overflow: hidden;
				}

				.list-tips {
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 5px 17px 0;

						.article-tags-wrap {
								display: flex;
								cursor: pointer;
						}

						.article-tags {
								display: flex;
								border: 1px solid var(--color-border);
								margin-right: 15px;
								padding: 3px 5px;
								border-radius: 14px;

								.tags-icon {
										width: 18px;
										height: 18px;
										margin-right: 4px;
										background: #DD0515;
										border-radius: 14px;
										color: #fff;
										line-height: 18px;
										text-align: center;
								}

								.tags-name {
										font-size: 12px;
										color: var(--color-text);
								}
						}

						span {
								color: var(--color-text-a);
						}

						a,.sign {
								width: 78px;
								height: 28px;
								background: #DD0515;
								border-radius: 4px;
								text-align: center;
								line-height: 28px;
								color: #fff;
						}

						.end-btn {
								background: #F3F4F7;
								color: var(--color-text-opacity);
						}

						.begin-btn {
								background: rgba(207, 23, 29, 0.1);
								border: 1px solid #DD0515;
								color: var(--color-text-a);
						}
				}

				.list-txt {
						display: flex;
						justify-content: space-between;
						margin-top: 10px;
						padding: 0 17px;
						font-size: 12px;
						color: var(--color-text-opacity);
						line-height: 22px;
				}
				.list-txtd {
						padding: 0 17px;
						font-size: 12px;
						margin-bottom: 10px;
						color: var(--color-text-opacity);
						line-height: 22px;
				}
		}

		li:nth-of-type(3n) {
				margin-right: 0;
		}

		li:hover {
				position: relative;
				box-shadow: 0 2px 8px 0 rgba(34, 123, 255, .36);
				border-radius: 6px;
				z-index: 1
		}
}
</style>